import { Component, OnInit, Input } from '@angular/core';
import { ModalController} from '@ionic/angular';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { Capacitor } from '@capacitor/core';

import { UntypedFormGroup, UntypedFormBuilder, Validators } from "@angular/forms";

import { WorkItem } from '../models/work-item';
import { ApiService } from '../services/api.service';

import { Router } from '@angular/router';

import { CurrencyService } from '../currency-service.service';

@Component({
  selector: 'app-work-item-edit',
  templateUrl: './work-item-edit.component.html',
  styleUrls: ['./work-item-edit.component.scss']
})
export class WorkItemEditComponent implements OnInit {

  @Input() public workItemToUpdate: WorkItem;
  @Input() currencyCode: string;
  @Input() taxName: string;

  isNativePlatform = true;
  ionicForm: UntypedFormGroup;
  isSubmitted = false;

  // This raw rate is used as typed by user
  rate: number;

  constructor(public modalCtrl: ModalController, public formBuilder: UntypedFormBuilder, public apiService: ApiService, public router: Router, private currencyService: CurrencyService) { }

  ngOnInit() {
    this.isNativePlatform = Capacitor.isNativePlatform();

    this.rate = this.workItemToUpdate.rate;

    // Build Product Form
    this.ionicForm = this.formBuilder.group({
      name: [this.workItemToUpdate?.name, [Validators.required, Validators.minLength(2)]],
      description: [this.workItemToUpdate?.description],
      rate: [this.currencyService.formatCurrency(this.workItemToUpdate?.rate, this.currencyCode), [Validators.required]],
      quantity: [this.workItemToUpdate?.quantity, [Validators.required]],
      hasTax: [this.workItemToUpdate?.hasTax],
      taxRate: [this.workItemToUpdate?.taxRate]
    });

  }

  dismiss() {  
    this.modalCtrl.dismiss();
  }

  private prepareSave(): WorkItem {
    var newModel = new WorkItem().deserialize(this.ionicForm.value);
    newModel.id = this.workItemToUpdate.id;
    return newModel;
  }

  totalPreview() {
    return this.workItemToUpdate.totalPreview(this.rate, this.ionicForm.value.quantity, this.ionicForm.value.hasTax, this.ionicForm.value.taxRate);
  }

  subTotalPreview() {
    return this.workItemToUpdate.subTotalPreview(this.rate, this.ionicForm.value.quantity);
  }

  submitForm() {
    this.isSubmitted = true;

    if (!this.ionicForm.valid) {
      console.log('Please provide all the required values for a work item.')
      return false;
    } else {

      // Add the raw unformatted rate into the form
      this.ionicForm.value.rate = this.rate;

      // Save product information
      const updatedWorkItem = this.prepareSave(); // `updatedWorkItem` is now an instance of "WorkItem"

      // Close the modal
      this.modalCtrl.dismiss(updatedWorkItem); // TODO: Return data, although we should refresh previous view / form
    }
  }

  get errorControl() {
    return this.ionicForm.controls;
  }

  formatCurrency(event: any) {
    // CurrencyService handles the updating of the value through the event
    // this.rate is us maintaining the user raw input for saving via the API
    this.rate = parseInt(this.currencyService.formatCurrencyEvent(event, this.currencyCode));
  }

}
